<template>
  <div class="exh_item">
    <div class="left_item">
      <a
        :title="item.exhibitionAlias"
        :href="`/exhibition/${item.exhibitionId}.html`"
        target="_blank">
        <NuxtImg
          :alt="item.exhibitionName"
          :src="coverImg(item.pic || item.logo)"
          class="not-watermark"
          loading="lazy"
          rel="nofollow,noindex" />
      </a>
    </div>
    <div class="right_item">
      <div
        class="En"
        @click="handleDetail">
        <div class="En_name">
          <!--          <nuxt-link :to="`/exhibition/${item.exhibitionId}.html`" :title="item.exhibitionEnglishName" target="_blank">-->
          {{ item.exhibitionEnglishName }}
          <!--          </nuxt-link>-->
        </div>
      </div>
      <div class="name_remind">
        <a
          :title="`${item.aliasPrimary || item.exhibitionName}`"
          :href="`/exhibition/${item.exhibitionId}.html`"
          target="_blank">
          {{ item.exhibitionName }}
        </a>
      </div>
      <div
        class="time_remind"
        @click="handleDetail">
        <span>
          <template v-if="isLogin || isShowTime">
            <template v-if="item.dynamic == 0">{{ item.lunchTime }}</template>
            <template v-else>{{ item.changeTime || item.lunchTime }}</template>
          </template>
          <template v-else>
            {{
              item.changeTime ? item.changeTime.substring(0, 7) : item.lunchTime.substring(0, 7)
            }}...
            <span
              @click.stop="clickLogin"
              style="font-size: 14px; cursor: pointer">
              {{ $t('exhibitionDetail.viewTime') }}
            </span>
          </template>
        </span>
      </div>
      <div
        class="time_remind"
        @click="handleDetail">
        <div
          v-if="item.hot"
          class="hot">
          <!-- 使用图标字体 -->
          <i class="iconfont el-icon-fire" title="火热图标"></i>
          <div class="hot_num">{{ numFormat(item.hot) }}{{ $t('exhibition.visitorViews') }}</div>
        </div>
      </div>
      <div class="avatar_div">
        <div
          v-if="item.exhibitionFollows && item.exhibitionFollows.length > 0"
          class="avatar-list">
          <div
            class="avatar_box">
            <!-- <NuxtImg
              :src="`${data.avatar ? data.avatar + getXOssWebpSize({ w: 26, h: 26 }) : ''}`"
              :alt="$t('personal.avatar')"
              class="set-img"
              loading="lazy"
              rel="nofollow,noindex"
              :title="$t('personal.avatar')" /> -->
              <!-- :src="`${data.avatar ? handlerReplaceImageHost(data.avatar + getXOssWebpSize({ w: 26, h: 26 }))  : ''}`" -->
              <!-- https://dcdn-jufair.jufair.com/jufair/exhibition-follower-avatar/4371.png -->
            <NuxtImg
              :alt="$t('personal.avatar')"
              :src="getWebp(`https://dcdn-jufair.jufair.com/jufair/exhibition-follower-avatar/${item.exhibitionId}.png`)"
              class="set-img"
              loading="lazy"
              rel="nofollow,noindex"
              :title="$t('personal.avatar')"
              @error="handleAvatarError" />
          </div>
        </div>
        <div class="avatar_name">
          {{ item.exhibitionFollows.length ? item.exhibitionFollows[0].companyName : '' }}
        </div>
      </div>
      <div class="btn_remind">
        <fair-tag
        :exhibitionName="item.aliasPrimary || item.exhibitionName"
          :exhibition-id="item.exhibitionId"
          :tag-num="2" />
        <div
          v-if="item.countDays > 0"
          class="distance">
          {{ $t('home.hot_recommend.distance') }}
          <span>{{ item.countDays }}</span>
          {{ $t('home.hot_recommend.day') }}
        </div>
        <div
          v-else-if="item.countDays === 0"
          class="distance"
          style="font-size: 14px">
          {{ $t('home.hot_recommend.openness') }}
        </div>
        <div
          v-else
          class="distance">
          {{ $t('home.hot_recommend.timeUpdate') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { inject, type Ref } from 'vue'
  import FairTag from '~/components/Goods/fairTag.vue'
  import { getXOssWebpSize ,handlerReplaceImageHost} from '~/utils/common'
  import {getWebp,handleAvatarError} from '~/utils/common'


  const props = defineProps({
    item: {
      type: Object,
      default: () => ({})
    },
    isShowTime: {
      type: Boolean,
      default: false
    }
  })

  defineEmits(['handleDetail'])

  const router = useRouter()
  const { t: $t } = useI18n()

  const handleDetail = () => {
    const text = router.resolve({
      path: `/exhibition/${props.item.exhibitionId}.html`
    })
    window.open(text.href, '_blank')
  }

  const coverImg = (value: string) => {
    try {
      return getWebp(JSON.parse(value)[0])
    } catch (e) {
      return value
    }
  }
  const globalStore = useGlobalStore()
  let isLogin = ref(null as any)
  if (import.meta.client) {
    isLogin = computed(() => globalStore.isLogin)
  }
  // 使用 inject 获取 loginModal，避免 inject 警告
  const loginModal = inject<Ref<any> | null>('loginModal', null)
  const clickLogin = () => {
    if (!isLogin.value) {
      return loginModal?.value?.open()
    }
  }
</script>

<style lang="less" scoped>
  .exh_item {
    width: 362px;
    display: flex;
    padding: 14px 0 14px 14px;
    margin-bottom: 8px;
    background: #fff;
    border-radius: 6px;

    &:hover {
      .left_item {
        img {
          transform: scale(1.2);
        }
      }
    }

    .left_item {
      width: 88px;
      height: 88px;
      flex-shrink: 0;
      margin-right: 14px;
      // border: 1px solid #ddd;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      img {
        width: 120px;
        height: auto;
        transition: all 0.3s;
      }
    }

    .right_item {
      width: calc(100% - 100px);
      box-sizing: border-box;
      padding: 0 12px 0 0;

      .En {
        display: flex;
        margin-bottom: 8px;
        cursor: pointer;

        .En_name {
          font-size: 18px;
          font-weight: bold;
          color: @app-color;
          flex: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          a {
            color: @app-color;
          }
        }
      }

      .name_remind {
        font-size: 16px;
        color: #333;
        letter-spacing: 1px;
        margin-bottom: 5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }

      .time_remind {
        font-size: 16px;
        color: #333;
        cursor: pointer;
        margin-bottom: 5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .hot {
          display: flex;
          align-items: center;

          img {
            height: 15px;
            width: auto;
            margin-right: 5px;
          }

          .hot_num {
            font-size: 16px;
            color: #333;
          }
        }
      }

      .avatar_div {
        display: flex;
        align-items: center;
        height: 28px;

        .avatar-list {
          display: flex;
          width: 130px;

          .avatar_box {
            margin-left: -8px;

            .set-img {
              height: 26px;
              object-fit: contain;
            }

            &:first-child {
              margin-left: 0;
            }
          }
        }

        .avatar_name {
          width: 100px;
          font-size: 14px;
          // flex: 1;
          text-align: center;
          overflow: hidden; /* 隐藏溢出内容 */
          text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
          white-space: nowrap; /* 防止文本换行 */
        }
      }

      .btn_remind {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .follow {
          font-size: 12px;
          color: #333;
          padding: 3px 6px;
          background: #fff;
          border-radius: 4px;
          border: 1px solid #cdcfd6;
          margin-right: 8px;
          cursor: pointer;
        }

        .distance {
          font-size: 14px;
          color: #333;
          margin-left: auto;

          span {
            color: #ff8600;
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>
